import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49f1b7af")

_pushScopeId("data-v-49f1b7af")
const _hoisted_1 = { class: "ana-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("dt", null, "正确答案", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查看代码")
const _hoisted_4 = /*#__PURE__*/_createVNode("dt", null, "解析", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("dl", null, [
      _hoisted_2,
      _createVNode("dd", null, [
        (_ctx.questionType === 1 || _ctx.questionType === 2 || _ctx.questionType === 4)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.answer), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.questionType === 3)
          ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.answer, (item, index) => {
              return (_openBlock(), _createBlock("p", { key: index }, _toDisplayString(index + 1 + '.' + item), 1))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.questionType === 5)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              class: "btn-code",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleViewCode(_ctx.analysisData.lang, _ctx.answer)))
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _hoisted_4,
      _createVNode("dd", null, _toDisplayString(_ctx.analysisData.analysis), 1)
    ])
  ]))
})